
import Vue from "vue";

export default Vue.extend({
  name: "AppOverlayLoader",
  data() {
    return {
      loading_animation: require("@/assets/illustrations/63zIg6PoGR.json")
    };
  },
  props: {
    overlay: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: "Analyzing..."
    }
  },
  created() {
    this.loading_animation = JSON.stringify(this.loading_animation);
  }
});
